import { Button, Card, CardBody, CardTitle } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  handleFormPost,
  handleFormSave,
  handleOPSJRFDeleteFunc,
} from "../commonHandlerFunction/JRFHandlerFunctions";
import React, { useState } from "react";
import PropTypes from 'prop-types';
import DeleteConfirmation from "../deleteConfirmation";
import ConfirmationModal from "../ConfirmationModal";
import { checkIsCancelApprovalUser, getCurrentRole } from "../../../services/commonFunction";
import { decryptDataForURL } from "../../../utills/useCryptoUtils";
import { useNavigate } from "react-router-dom";
const JRFButtons = ({ setIsPopupOpen, setJRFCreationType, handleSubmit, viewOnly, handleBackButtonFunction, setIsOverlayLoader, formData, setIsRejectPopupOpen, setIsCancelPopupOpen }) => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const translate = t;
  const [isDelete, setIsDelete] = useState(false)
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const useFor = decryptDataForURL(params.get("useFor"));
  const getPopupMesg = () => {
    return (<>
      <CardBody>
        <CardTitle tag="h5">
          Are you sure you want to delete this JRF record?
        </CardTitle>
        <CardTitle tag="h5">
          This action will also delete all associated groups and parameters. This cannot be undon.
        </CardTitle>
      </CardBody>
    </>)
  }
  const openDeletePopup = () => {
    let headingMsg = "Confirmation!";
    let titleMsg = "";
    headingMsg = "Confirmation!";
    titleMsg = "Are you sure you want to delete this JRF record? \n This action will also delete all associated groups and parameters. This cannot be undone.";
    return (
      // <DeleteConfirmation
      //   isOpen={isDelete}
      //   handleClose={setIsDelete}
      //   handleConfirm={() => handleOPSJRFDeleteFunc(formData[0]?.jrf_id, setIsOverlayLoader, handleBackButtonFunction)}
      //   popupMessage={titleMsg}
      //   popupHeading={headingMsg}
      //   actionType={"Delete"}
      // />
      <ConfirmationModal isOpen={isDelete} handleClose={() => setIsDelete(false)} handleConfirm={() => handleOPSJRFDeleteFunc(formData[0]?.jrf_id, setIsOverlayLoader, handleBackButtonFunction)} popupMessage={getPopupMesg()} popupHeading={headingMsg} popbuttons={{ no: "Cancel", yes: "Delete" }} />
    );
  };

  return (
    <div className="submit_btns">
      {
        isDelete && openDeletePopup()
      }
      <Button
        type="button"
        className="cancelBtn"
        id="submit_btn3"
        onClick={() => {
          navigate(-1)
        }}
      >
        {translate("common.backBtn")}
      </Button>
      {
        useFor === "CancelJob" ? !checkIsCancelApprovalUser(formData[0]?.jrf_lab_detail?.lab_is_compliant) ? (<Button
          type="button"
          className="submitBtn"
          id="submit_btn1"
          onClick={(e) => {
            setIsRejectPopupOpen(true)
            setIsCancelPopupOpen(true)
          }
          }
        >
          {(["created", "saved", 'inwarded', 'assigning', 'assigned', 'test memo created'].includes(formData[0]?.inward_details?.smpl_status) || ['posted', 'accepted'].includes(formData[0]?.jrf_status) && formData[0]?.jrf_lab_detail?.lab_is_compliant) ? 'Cancel JRF' : 'Request Cancellation'}
        </Button>) :
          <>
            <Button
              type="button"
              className="submitBtn"
              id="submit_btn1"
              onClick={(e) => {
                setIsRejectPopupOpen(true)
                setIsCancelPopupOpen(false)
              }
              }
            >
              Reject
            </Button>
            <Button
              type="button"
              className="submitBtn"
              id="submit_btn1"
              onClick={(e) => {
                setIsRejectPopupOpen(true)
                setIsCancelPopupOpen(true)
              }
              }
            >
              Cancel JRF
            </Button>
          </>
          : null
      }
      {!viewOnly && (
        <React.Fragment>

          <button
            type="button"
            className="saveBtn"
            id="submit_btn2"
            data-name="save"
            onClick={(e) =>
              handleFormSave(
                e,
                handleSubmit,
                setIsPopupOpen,
                setJRFCreationType
              )
            }
          >
            {translate("common.saveBtn")}
          </button>
          {!['SU'].includes(getCurrentRole()) && <Button
            type="button"
            className="submitBtn"
            id="submit_btn1"
            onClick={(e) =>
              handleFormPost(
                e,
                handleSubmit,
                setJRFCreationType,
                setIsPopupOpen
              )
            }
          >
            {translate("common.postBtn")}
          </Button>}
          {
            formData[0]?.jrf_status === "rejected" && formData[0]?.jrf_is_ops ?
              <Button
                type="button"
                className="submitBtn"
                id="submit_btn1"
                onClick={(e) =>
                  setIsDelete(true)
                }
              >
                Delete JRF
              </Button> : null
          }

        </React.Fragment>
      )}
    </div>
  );
};


JRFButtons.propTypes = {
  setIsPopupOpen: PropTypes.func,
  setJRFCreationType: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleBackButtonFunction: PropTypes.func,
  viewOnly: PropTypes.bool,
};

export default JRFButtons;
